import { Field } from 'formik'
import classnames from 'classnames'
import { ButtonDrawer, InputField } from '~/components'
import { useTranslation } from 'react-i18next'
import * as styles from './index.module.css'

const cx = classnames.bind(styles)

export default function AddMessage({ innerRef, isOptionsOpen, onClose }) {
  const { t } = useTranslation()

  return (
    <div className={styles.wrapper}>
        <div className={styles.title}>{t('title-message-to-driver')}</div>
        <Field name="generalComment" placeholder={t('title-message-to-driver')} tabIndex={isOptionsOpen ? 0 : -1} innerRef={innerRef} maxLength="30" component={InputField} />
        <ButtonDrawer buttons={[{ func: onClose, title: t('button-save')}]} />
    </div>
  )
}

